<div class="relogin-modal">
  <div
    class="nudge-icon-frame tw-mx-auto tw-mb-4 tw-w-fit tw-rounded-full tw-bg-primary-light tw-p-4"
    aria-hidden="true"
  >
    <div class="pitchin-icon pitchin-icon-shield-red tw-h-8 tw-w-8"></div>
  </div>

  <h2 class="relogin-title">{{ 'login.reloginModal.title' | translate }}</h2>
  <p class="relogin-intro">{{ 'login.reloginModal.intro' | translate }}</p>

  <form [formGroup]="form" (ngSubmit)="submit()" class="relogin-form">
    <div class="mb-3">
      <label class="form-label" for="relogin_email">{{ 'common.email' | translate }}</label>
      <input id="relogin_email" class="form-control" type="email" [value]="email" disabled />
    </div>

    <div class="mb-3">
      <label class="form-label" for="relogin_password">{{ 'login.password' | translate }}</label>
      <input
        class="form-control"
        type="password"
        formControlName="password"
        id="relogin_password"
        maxlength="30"
        autofocus
      />
    </div>

    @if (errorMessage) {
      <div class="relogin-error">{{ errorMessage | translate }}</div>
    }

    <div class="relogin-actions">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid || submitting"
      >
        {{ 'login.reloginModal.submit' | translate }}
      </button>
      <button type="button" class="btn btn-link relogin-cancel" (click)="cancel()">
        {{ 'common.cancel' | translate }}
      </button>
    </div>
  </form>
</div>
